import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button"]
  static values = {
    openText: { type: String, default: "View more filters" },
    closedText: { type: String, default: "View less filters" }
  }

  connect() {
    this.updateButtonText()
  }

  toggle(event) {
    if (event) event.preventDefault()
    
    this.contentTarget.classList.toggle("d-none")
    this.updateButtonText()
  }

  updateButtonText() {
    const isHidden = this.contentTarget.classList.contains("d-none")
    this.buttonTarget.innerText = isHidden ? this.openTextValue : this.closedTextValue
  }
}
